module.exports = __webpack_public_path__ + "img/song-recorder.a488fdd5.svg";